import { createRules } from "../../functions";

export const OpenStationdRules = createRules({
    image: { required: false },
})